import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFormStore } from '../../state/FormStore';


export function SandwichPanel({ verandaSize, verandaColor, opaalTexture, verandaStartPosition, nodes, materials }) {
    const { formData } = useFormStore();


    return (

        <group scale={[verandaSize[0], verandaSize[1], verandaSize[2]]}>
            {formData.linker.linker_wand_option === 'Sandwich paneel' && formData.linker.linker_spie_option !== 'Geen' && (
                <>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_left_ws.geometry}
                        material={materials['Material.004']}
                    />
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_left_ws_1.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                </>
            )}

            {formData.linker.linker_wand_option === 'Sandwich paneel' && formData.linker.linker_spie_option === 'Geen' && (
                <>
                    {/* Replace these with the other meshes you want to show */}
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_left.geometry}
                        material={materials['Material.004']}
                    />
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_left_1.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_left_2.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                </>
            )}


            {formData.rechter.rechter_wand_option === 'Sandwich paneel' && formData.rechter.rechter_spie_option !== 'Geen' && (
                <>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_right_ws.geometry}
                        material={materials['Material.004']}
                    />
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_right_ws_1.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                </>
            )}

            {formData.rechter.rechter_wand_option === 'Sandwich paneel' && formData.rechter.rechter_spie_option === 'Geen' && (
                <>
                    {/* Replace these with the other meshes you want to show */}
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_right.geometry}
                        material={materials['Material.004']}
                    />
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_right_1.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.sandwich_panel_right_2.geometry}
                        material={materials.silver}>
                        <meshStandardMaterial attach="material" color={verandaColor[0]} />
                    </mesh>
                </>
            )}



        </group>
    );
}

//useGLTF.preload('/veranda3/veranda3.glb');
